// extracted by mini-css-extract-plugin
module.exports = {"floors":"ParkingSlots_floors__3_ncA","mid":"ParkingSlots_mid__39vYB","img":"ParkingSlots_img__aR8uO"};